import type { PbxLocationsLocale } from './en'

export const pbxLocationsFrCa = {
  header: `Emplacements`,
  headerSubtext: `Gérez les emplacements de bureau de ce PBX. Chaque emplacement correspond à un numéro de téléphone E911 qui sera utilisé comme identifiant de l'appelant pour les appels d'urgence.`,
  addLocation: `Ajouter un emplacement`,
  searchPlaceholder: `Rechercher des emplacements`,
  empty: `Aucun emplacement n'est encore configuré pour ce PBX.`,
  loadError: `Échec du chargement des emplacements.`,
  column: {
    name: `Nom`,
    extensionCount: `Postes`,
    e911Number: `Numéro E911`,
    e911Address: `Adresse E911`,
    actions: `Actions`,
  },
  notConfigured: `Non configuré`,
  notConfiguredE911Number: `Aucun numéro E911 attribué`,
  notConfiguredE911Address: `Aucune adresse E911 au dossier`,
  edit: `Modifier`,
  delete: `Supprimer`,
  extensionCountLabel_one: `{{count}} poste`,
  extensionCountLabel_other: `{{count}} postes`,
  form: {
    createHeader: `Ajouter un emplacement`,
    editHeader: `Modifier l'emplacement`,
    nameLabel: `Nom`,
    namePlaceholder: `e.g. Main Office`,
    nameRequired: `Le nom est requis`,
    phoneNumberLabel: `Numéro de téléphone E911`,
    phoneNumberPlaceholder: `Sélectionnez un numéro de téléphone`,
    phoneNumberHelp: `L'adresse E911 de ce numéro sera utilisée pour les appels d'urgence effectués depuis cet emplacement.`,
    noAvailableNumbers: `Aucun numéro de téléphone n'est disponible pour l'attribution.`,
    loadingAvailableNumbers: `Chargement des numéros disponibles...`,
    cancel: `Annuler`,
    save: `Enregistrer`,
    create: `Créer l'emplacement`,
    update: `Mettre à jour l'emplacement`,
    createSuccess: `Emplacement créé.`,
    updateSuccess: `Emplacement mis à jour.`,
    createError: `Échec de la création de l'emplacement.`,
    updateError: `Échec de la mise à jour de l'emplacement.`,
  },
  deleteModal: {
    header: `Supprimer l'emplacement`,
    confirmMessage: `Voulez-vous vraiment supprimer « {{name}} »? Cette action est irréversible.`,
    reassignPrompt_one: `{{count}} poste est attribué à cet emplacement et doit être réattribué avant la suppression. Choisissez un nouvel emplacement :`,
    reassignPrompt_other: `{{count}} postes sont attribués à cet emplacement et doivent être réattribués avant la suppression. Choisissez un nouvel emplacement :`,
    reassignSelectPlaceholder: `Sélectionnez un emplacement de destination`,
    noOtherLocations: `Il n'y a aucun autre emplacement sur ce PBX. Créez d'abord un autre emplacement.`,
    cancel: `Annuler`,
    confirm: `Supprimer`,
    confirmReassign: `Réattribuer et supprimer`,
    success: `Emplacement supprimé.`,
    error: `Échec de la suppression de l'emplacement.`,
  },
} satisfies PbxLocationsLocale
